import { addDays } from 'date-fns'
import { HistoricoPayload } from 'graphql/types.generated'
import { partition } from 'util/array'
import { isBetween } from 'util/date/compare'
import { isEmpty } from 'util/validation/Util'

import { AcompanhamentoUltimosContatosModel } from '../../folha-rosto/components/ultimos-contatos/converter-ultimosContatos'
import { TipoPuerperio } from './model-acompanhamentoPuerperio'

export const getTipoPuerperio = (dataReferencia: Date, dataInicioPuerperio: Date): TipoPuerperio => {
  if (isBetween(dataReferencia, dataInicioPuerperio, addDays(dataInicioPuerperio, 7))) {
    return TipoPuerperio.IMEDIATO
  }
  return TipoPuerperio.TARDIO
}

export const completeConsultasPuerperio = (
  historico: HistoricoPayload,
  dataInicioCondicao: Date
): AcompanhamentoUltimosContatosModel[] => {
  const consultasHistorico = historico?.content
  const [imediatos, tardios] = partition(
    consultasHistorico || [],
    (consulta: AcompanhamentoUltimosContatosModel) =>
      getTipoPuerperio(consulta?.dataAtendimento, dataInicioCondicao) === TipoPuerperio.IMEDIATO
  )

  const consultasPuerperio: AcompanhamentoUltimosContatosModel[] = [...(consultasHistorico ?? [])]

  if (isEmpty(imediatos)) {
    consultasPuerperio.unshift({
      dataAtendimento: addDays(dataInicioCondicao, 1),
      isAtendRecente: false,
      hasMarcadorConsumoAlimentar: false,
    })
  }

  if (isEmpty(tardios)) {
    consultasPuerperio.push({
      dataAtendimento: addDays(dataInicioCondicao, 8),
      isAtendRecente: false,
      hasMarcadorConsumoAlimentar: false,
    })
  }
  return consultasPuerperio
}
